var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 17"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "user-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.914.5h16v16h-16z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#user-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.61 9.833H6.218a3.31 3.31 0 0 0-3.305 3.305V16.5h12v-3.362a3.31 3.31 0 0 0-3.305-3.305M8.914 8.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
}))));
export { SvgUserIcon as ReactComponent };
export default __webpack_public_path__ + "f76dd6916c5656d7f5f4ef911ee6057d.svg";